module.exports = __webpack_public_path__ + "7eaefc77dd31d4143a600faad72ee887.svg";